<div
  class="top-bar-categories flex align-items-center mb-3"
  [class.p-0]="innerWidth < 450"
  [class.ps-4]="innerWidth < 450"
  (window:resize)="onResize($event)"
>
  <div class="title flex align-items-center me-auto">
    <i _ngcontent-serverapp-c11="" class="fas fa-tachometer-alt me-3"></i>
    <h5>Mi perfil</h5>
    <h2 class="float-start">
      Bienvenido(a) {{ session.firstName || '' | titlecase }}
      {{ session.lastName || '' | titlecase }}
    </h2>
  </div>
</div>

<div class="dashboard row m-0">
  <div class="col-lg-4 mb-3">
    <div class="card h-100">
      <div class="card-header">Datos empresa</div>
      <div class="card-body card-body-min-height-loading">
        <app-loading-element
          [text]="'Cargando información cliente'"
          *ngIf="loadingClient || !dataClient; else datosCliente"
        >
        </app-loading-element>

        <ng-template #datosCliente>
          <div class="img-enterprise"></div>
          <div>
            <span class="title2">Nombre / Razón Social</span
            >{{ dataClient.name }}
          </div>
          <div>
            <span class="title2">{{ config.document.name }}</span
            >{{ dataClient.documentId }}
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="col-lg-4 mb-3">
    <div class="card h-100">
      <div class="card-header">
        Datos personales:
        <div class="float-end">
          <button
            name="openModalEdit"
            (click)="openModalEditProfile()"
            class="btn btn-sm btn-secondary text-center"
            name="editarPerfil"
          >
            <i class="far fa-edit"></i>
          </button>
        </div>
      </div>

      <div class="card-body card-body-min-height-loading">
        <app-loading-element
          [text]="'Cargando información cliente'"
          *ngIf="loadingClient"
        >
        </app-loading-element>

        <div class="big-title">
          {{ session.firstName || '' | titlecase }}
          {{ session.lastName || '' | titlecase }}
        </div>

        <div><span class="title2">Usuario</span>{{ session.username }}</div>
        <div>
          <span class="title2">Email de Contacto</span>{{ session.email }}
        </div>
        <div><span class="title2">Teléfono</span>{{ session.phone }}</div>
        <div class="mt-3">
          <a href="javascript:" (click)="openModalPassword()"
            >¿Desea cambiar la contraseña? <i class="fas fa-key"></i
          ></a>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-4 mb-3">
    <div class="card h-100">
      <div class="card-header">Preferencias</div>
      <div class="card-body card-body-min-height-loading">
        <app-loading-element
          [text]="'Cargando información cliente'"
          *ngIf="loadingClient"
        >
        </app-loading-element>
        <div class="row mt-3">
          <div class="col-5 title2 m-0"><span>Precios productos:</span></div>
          <div class="col-7">
            <div class="form-check form-switch">
              <input
                type="checkbox"
                class="form-check-input"
                id="tax"
                [checked]="session.preferences.iva ? true : false"
                (change)="updateTaxPreference()"
                style="cursor: pointer"
              />
              <label
                class="form-check-label"
                for="tax"
                style="
                  cursor: pointer;
                  font-weight: normal;
                  padding-left: 10px;
                "
                >{{
                  session.preferences.iva
                    ? taxConfig.labelWithTax
                    : taxConfig.labelWithoutTax
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-5 flex align-items-center title2 m-0">
            <span>Dirección despacho predeterminada:</span>
          </div>
          <div class="col-7 flex align-items-center">
            <div class="text-start">
              {{
                direccionDespacho?.street + ' ' + direccionDespacho?.number
                  | capitalizeFirst
              }}
            </div>
            <div tooltip="Modificar dirección">
              <button
                class="btn btn-sm btn-link"
                (click)="modificarDireccionDespacho()"
              >
                <i class="fas fa-pencil-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="lg:col-12 mb-3">
    <ng-container>
      <p-tabMenu
        [model]="items"
        [activeItem]="activeItem"
        [ngStyle]="{
          display: 'flex',
          'justify-content': 'space-between',
          width: '100%'
        }"
        (onTabChange)="onTabChange($event)"
      >
      </p-tabMenu>

      <p-card class="p-mb-3 p-d-flex p-jc-center">
        <div *ngIf="activeItem?.label === 'Direcciones'">
          <div class="p-table-responsive">
            <p-table
              #dt
              [value]="addresses"
              [rows]="10"
              [paginator]="true"
              [rowHover]="true"
              dataKey="id"
              styleClass="p-datatable-striped p-datatable-sm"
              [tableStyle]="{ 'min-width': '15rem' }"
              currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} resultados"
              responsiveLayout="stack"
              [breakpoint]="'800px'"
              [columnResizeMode]="'expand'"
              class="custom-stack-table"
            >
              <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                  <button
                    pButton
                    pRipple
                    label="Crear"
                    icon="pi pi-plus"
                    class="p-button-sm"
                    (click)="openModalAddAddress()"
                  ></button>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr *ngIf="!isMobile">
                  <th>Tipo</th>
                  <th>Comuna</th>
                  <th>Localidad</th>
                  <th>Calle</th>
                  <th>Número</th>
                  <th>Dpto</th>
                  <th>Referencia</th>
                  <th>Acciones</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-address>
                <tr>
                  <td
                    [ngClass]="{
                      'hidden p-0': !address.type && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        address.type
                    }"
                  >
                    <div class="p-column-title font-bold">Tipo</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ address.type }}
                    </div>
                  </td>

                  <td
                    [ngClass]="{
                      'hidden p-0': !address.city && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        address.city
                    }"
                  >
                    <div class="p-column-title font-bold">Comuna</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ address.city }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !address.location && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        address.location
                    }"
                  >
                    <div class="p-column-title font-bold">Localidad</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ address.location }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !address.street && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        address.street
                    }"
                  >
                    <div class="p-column-title font-bold">Calle</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ address.street }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !address.number && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        address.number
                    }"
                  >
                    <div class="p-column-title font-bold">Numero</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ address.number }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !address.departmentHouse && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        address.departmentHouse
                    }"
                  >
                    <div class="p-column-title font-bold">Depto</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ address.departmentHouse }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !address.reference && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        address.reference
                    }"
                  >
                    <div class="p-column-title font-bold">Referencia</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ address.reference }}
                    </div>
                  </td>
                  <td
                    class="justify-content-center gap-3"
                    [ngClass]="{
                      'border-gray-400 border-bottom-3': isMobile
                    }"
                  >
                    <button
                      pButton
                      pRipple
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-success p-button-sm"
                      (click)="openModalUpdateAddAddress(address)"
                    ></button>
                    <button
                      *ngIf="address.type !== 'Factura'"
                      pButton
                      pRipple
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-warning p-button-sm"
                      (click)="deleteAddress(address)"
                    ></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <div *ngIf="activeItem?.label === 'Contactos'">
          <div class="p-table-responsive">
            <p-table
              #dt
              [value]="contacts"
              [rows]="10"
              [paginator]="true"
              [rowHover]="true"
              dataKey="id"
              styleClass="p-datatable-striped p-datatable-sm"
              [tableStyle]="{ 'min-width': '15rem' }"
              currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} resultados"
              responsiveLayout="stack"
              [breakpoint]="'800px'"
            >
              <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                  <button
                    pButton
                    pRipple
                    label="Crear"
                    icon="pi pi-plus"
                    class="p-button-sm"
                    (click)="openModalAddContact()"
                  ></button>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr *ngIf="!isMobile">
                  <th>Documento</th>
                  <th>Nombre</th>
                  <th>Cargo</th>
                  <th>Teléfono</th>
                  <th>Email</th>
                  <th>Tipo</th>
                  <th>Acciones</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-contact>
                <tr>
                  <td
                    [ngClass]="{
                      'hidden p-0': !contact.documentId && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        contact.documentId
                    }"
                  >
                    <div class="p-column-title font-bold">Documento</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ contact.documentId }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0':
                        !contact.name && !contact.lastName && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        contact.name
                    }"
                  >
                    <div class="p-column-title font-bold">Nombre</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ contact.name }} {{ contact.lastName }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !contact.position && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        contact.position
                    }"
                  >
                    <div class="p-column-title font-bold">Cargo</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ contact.position }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !contact.phone && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        contact.phone
                    }"
                  >
                    <div class="p-column-title font-bold">Telefono</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ contact.phone }}
                    </div>
                  </td>

                  <td
                    [ngClass]="{
                      'hidden p-0': !contact.email && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        contact.email
                    }"
                  >
                    <div class="p-column-title font-bold">Email</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ contact.email }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !contact.email && isMobile,
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        contact.email
                    }"
                  >
                    <div class="p-column-title font-bold">Tipo</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ contact.contactType }}
                    </div>
                  </td>
                  <td
                    class="justify-content-center gap-3"
                    [ngClass]="{
                      'border-gray-400 border-bottom-3': isMobile
                    }"
                  >
                    <button
                      pButton
                      pRipple
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-success p-button-sm"
                      (click)="openModalUpdateContact(contact)"
                    ></button>
                    <button
                      pButton
                      pRipple
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-warning p-button-sm"
                      (click)="deleteContact(contact)"
                    ></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div *ngIf="activeItem?.label === 'Usuarios'">
          <app-tabla-usuario [userSession]="session"></app-tabla-usuario>
        </div>
      </p-card>
    </ng-container>
  </div>

  <ng-template #modalAddress>
    <app-address-modal
      [modalAddressRef]="modalAddressRef"
      (respuesta)="respuesta($event)"
    ></app-address-modal>
  </ng-template>

  <ng-template #modalUpdateAddress>
    <app-update-address-modal
      [modalUpdateAddressRef]="modalUpdateAddressRef"
      [direccion]="direccionSeleccionada"
      (respuesta)="respuesta($event)"
    ></app-update-address-modal>
  </ng-template>

  <ng-template #modalAddContact>
    <app-add-contact-modal
      [modalAddContactRef]="modalAddContactRef"
      (respuesta)="respuesta($event)"
    ></app-add-contact-modal>
  </ng-template>

  <ng-template #modalUpdateContact>
    <app-update-contact-modal
      [modalUpdateContactRef]="modalUpdateContactRef"
      [contacto]="contactoSeleccionada"
      (respuesta)="respuesta($event)"
    ></app-update-contact-modal>
  </ng-template>

  <ng-template #modalEdit>
    <app-edit-profile-modal
      [modalEditRef]="modalEditRef"
      (respuesta)="respuesta($event)"
    ></app-edit-profile-modal>
  </ng-template>

  <ng-template #modalPassword>
    <app-password-modal
      [modalPasswordRef]="modalPasswordRef"
    ></app-password-modal>
  </ng-template>
</div>
